import { render, staticRenderFns } from "./IconGivecredit.vue?vue&type=template&id=bf89897a&"
import script from "./IconGivecredit.vue?vue&type=script&lang=js&"
export * from "./IconGivecredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports